import { getPeriodName, getPeriodRedditionLabel } from "helpers/utils";
import type { CSSProperties } from "react";
import { useTranslation } from "react-i18next";
import type { TPeriod } from "store/periodStore";

import StatusPill from "../ManagementPeriodComponent/StatusPill";
import "../ManagementPeriodComponent/style.scss";

interface IPeriodName {
    period: TPeriod | undefined;
    textStyle?: CSSProperties;
    containerStyle?: CSSProperties;
    /** Uses the term form period type label (e.g. "6 mois - 01/01/2024 ↔︎ 31/12/2024"). */
    variant?: "default" | "termForm";
}

function getPeriodLabel(
    period: TPeriod | undefined,
    variant: NonNullable<IPeriodName["variant"]>,
    monthsLabel: string,
): string {
    if (!period) return "";

    if (variant === "termForm") {
        return getPeriodRedditionLabel({ period, monthsLabel });
    }

    return getPeriodName({ period });
}

/**
 * Displays dates of period with status pill as seen in Management period selector.
 */
const PeriodName = ({ period, textStyle, containerStyle, variant = "default" }: IPeriodName) => {
    const [t] = useTranslation();

    const periodLabel = getPeriodLabel(period, variant, t("ConnectTitle.PeriodTypeMonth"));

    return period ? (
        <div style={{ ...style.container, ...containerStyle }}>
            <span style={{ ...style.text, ...textStyle }}>{periodLabel}</span>
            <StatusPill status={period.isActive} t={t} />
        </div>
    ) : (
        <></>
    );
};

export default PeriodName;

const style = {
    container: {
        display: "flex",
        alignItems: "center",
        gap: "0.5rem",
    },
    text: {
        fontSize: "0.75rem",
    },
};
